// Hardcoded NAICS verticals offered in the public signup form. Mirrors the
// rows in organization_naics that we actively market into. If a user picks
// "Other", they get a freeform text input and the backend stores it on
// the SignupSubmission but leaves company.naics null (the lookup is
// keyed on the id below, so any value not in this list ends up null).
export const NAICS_OPTIONS = [
  { id: "811111", title: "Automotive Repair" },
  { id: "811191", title: "Quick Lube" },
  { id: "56171", title: "Pest Control" },
  { id: "541940", title: "Pet Care" },
  { id: "811192", title: "Car Washes" },
  { id: "71391", title: "Golf Courses" },
  { id: "71394", title: "Gyms, Health & Fitness Clubs" },
];

export const NAICS_OTHER = "__other__";
